{
  "fr": {
    "global": {
      "all": "Tout afficher",
      "emptyFilterHeading": "Nous n'avons malheureusement trouvé aucun contenu correspondant.",
      "emptyFilterText": "Essayez un autre terme ou ajustez le filtre.",
      "filterContent": "Filtrer le contenu",
      "resetFilter": "Réinitialiser le filtre"
    },
    "activities": {
      "labels": {
        "noProject": "Sans projet"
      }
    },
    "alerts": {
      "exampleButton": "Insérer un exemple"
    },
    "appsInfo": {
      "shared": {
        "generalFeedback": "Feedback général",
        "introduction": "Cet outil vous offre de nombreuses possibilités d'utilisation pour l'école et l'enseignement :",
        "toolSpecificFaqs": "Questions sur l'outil {name}",
        "videoTutorial": "Comment fonctionne cet outil"
      }
    },
    "authorInfoModal": {
      "creativeCommons": "Ils sont sous la <a href='https://creativecommons.org/licenses/by/4.0/' target='_BLANK'>licence Creative Commons CC-BY 4.0</a>.",
      "header": "À propos de ces contenus",
      "listHeader": "Vous pouvez :",
      "listHtmlPublic": "<li><i class=\"bi bi-check2\"></i><strong>Partager</strong> — reproduire et diffuser les contenus sous n'importe quel format ou support.</li>\n<li><i class=\"bi bi-check2\"></i><strong>Modifier</strong> — remixer, transformer et s'appuyer sur les contenus pour tout usage, même commercial.</li>\n<li><i class=\"bi bi-exclamation-triangle\"></i>En cas de réutilisation, vous vous engagez à fournir des <strong>attributions appropriées</strong> et à <strong>nommer {name} comme auteur·e</strong>. Lors de la réutilisation avec les outils fobizz, ces conditions sont automatiquement remplies.</li>",
      "paragraphHtmlIntro": "Ces contenus ont été créés par <strong>{name}</strong> avec les <a href=\"https://app.fobizz.com/\" target=\"_blank\">outils fobizz</a>.",
      "paragraphHtmlPrivate": "Les contenus ne peuvent être partagés, reproduits ou diffusés <strong>qu'avec l'accord explicite de {name}</strong>.",
      "paragraphHtmlPrivateHead": "Ces contenus ont été partagés uniquement <strong>avec certaines personnes</strong> via un lien de partage.",
      "paragraphHtmlPublic": "Ces contenus ont été créés sur la base des <a href='{link}' target='_BLANK'>contenus de <strong>{name}</strong></a>."
    },
    "buttons": {
      "add": "Ajouter",
      "apply": "Utiliser",
      "cancel": "Annuler",
      "chooseFile": "Choisir un fichier",
      "clearSearch": "Effacer la recherche",
      "close": "Fermer",
      "copy": "Copier",
      "copySmall": "copier",
      "createContent": "Créer du contenu",
      "delete": "Supprimer",
      "deleteImage": "Supprimer l'image",
      "edit": "Modifier",
      "enableRecordingDevice": "Activer l'appareil d'enregistrement",
      "finished": "Terminé",
      "generatePreviewImage": "Générer une image",
      "generateSuggestion": "Générer une suggestion",
      "generateText": "Générer un texte",
      "go": "C'est parti",
      "insert": "Insérer",
      "insertElement": "Insérer un élément",
      "loadMore": "Charger plus",
      "move": "Déplacer",
      "next": "Suivant",
      "previous": "Retour",
      "reRecord": "Redémarrer l'enregistrement",
      "reload": "Recharger",
      "save": "Enregistrer",
      "select": "Sélectionner",
      "startRecording": "Démarrer l'enregistrement",
      "stopRecording": "Arrêter l'enregistrement",
      "submit": "Envoyer",
      "toggleFilterMenu": "Afficher/masquer le menu des filtres",
      "tryAgain": "Réessayer",
      "understood": "Compris",
      "uploadAnotherFile": "Télécharger un autre fichier",
      "uploadFile": "Télécharger un fichier",
      "useToolsUnlimited": "Utiliser fobizz illimité",
      "no": "Non",
      "yes": "Oui"
    },
    "confirmDialog": {
      "discardItem": {
        "confirm": "Déplacer",
        "text": "Le contenu ({modelName}) sera supprimé de votre aperçu. Vous le retrouverez ensuite dans la corbeille.",
        "title": "Déplacer le contenu dans la corbeille ?"
      },
      "promptCheckCancel": "Personnaliser",
      "promptContentFilter": {
        "confirm": "Envoyer",
        "text": "Nos filtres de sécurité ont classé votre saisie comme sensible. Vous pouvez l'adapter ou l'envoyer telle quelle.",
        "title": "Saisie bloquée"
      },
      "promptPrivacy": {
        "confirm": "Envoyer",
        "text": "Votre prompt semble contenir des données personnelles. Lors de l'envoi, il sera transmis à l'IA.",
        "title": "Données personnelles dans le prompt ?"
      }
    },
    "courses": {
      "labels": {
        "completed": "Terminé",
        "course": "Formation continue",
        "enrolled": "inscrit",
        "impulse": "Impulsion",
        "recording": "Enregistrement",
        "webinar": "Webinaire",
        "workshop": "Atelier",
        "b2bWorkshop": "Interne à l'école"
      }
    },
    "emptyState": {
      "ai": {
        "noHistoryDescription": "Essayez les outils IA pour créer de nouveaux contenus.",
        "noHistoryTitle": "Vous n'avez pas encore fait de demandes."
      }
    },
    "enums": {
      "autoCleanup": {
        "day": "1 jour",
        "month": "1 mois",
        "months_18": "18 mois",
        "never": "Jamais",
        "week": "1 semaine",
        "year": "1 an"
      },
      "companyKinds": {
        "kind_school": "École",
        "kind_community_college": "Université populaire",
        "kind_other": "Autre",
        "kind_teacher_training": "Séminaire d'études/Formation des enseignants",
        "kind_institute": "Institut de formation continue",
        "kind_media_center": "Centre de médias",
        "kind_college": "Université/École supérieure",
        "kind_company": "Entreprise/Organisations",
        "kind_government_agency": "Autorité/Administration",
        "kind_national_license": "Licence régionale",
        "kind_goethe_institute": "Institut Goethe",
        "kind_supporting_institution": "Autorité scolaire",
        "kind_tutoring": "Soutien scolaire",
        "kind_language_school": "École de langues"
      },
      "courseTargetGroupTypes": {
        "TARGET_GROUP_TYPE_TEACHERS": "Enseignant·e·s",
        "TARGET_GROUP_TYPE_SCHOOL_BOARDS": "Directions d'école",
        "TARGET_GROUP_TYPE_SCHOOL_EXECUTIVES": "Enseignant·e·s en position de direction",
        "TARGET_GROUP_TYPE_TEACHER_TRAINEES": "Étudiant·e·s en enseignement",
        "TARGET_GROUP_TYPE_STUDENT_TEACHERS": "Stagiaires",
        "TARGET_GROUP_TYPE_SCHOOL_LEADERS": "Directeur·trice·s d'école"
      },
      "gradeLevels": {
        "GRADE_LEVEL_1_2": "Classe 1/2",
        "GRADE_LEVEL_3_4": "Classe 3/4",
        "GRADE_LEVEL_HIGH": "Lycée",
        "GRADE_LEVEL_LOWER": "Collège",
        "GRADE_LEVEL_MIDDLE": "Cycle moyen"
      },
      "itemNodes": {
        "AudioRecorder::File": "Enregistrement audio",
        "LinkShortener::Link": "Raccourcir un lien",
        "ScreenRecorder::File": "Enregistrement d'écran",
        "Tools::Ai::Assistant": "Assistant IA",
        "Tools::Ai::Converter": "Contenu",
        "Tools::Ai::Feedback": "Aide à la correction IA",
        "Tools::Ai::Image": "Image IA",
        "Tools::ClassroomScreen::Screen": "Tableau numérique",
        "Tools::FileSharing::File": "Partager un fichier",
        "Tools::Pinboard::Board": "Tableau d'affichage",
        "Tools::Pinboard::Card": "Tableau d'affichage",
        "Tools::Pinboard::Comment": "Tableau d'affichage",
        "Tools::Pinboard::List": "Tableau d'affichage",
        "Tools::PupilFeedback::Assignment": "Feedback IA",
        "Tools::PupilFeedback::Feedback": "Feedback IA",
        "Tools::Surveys::Survey": "Sondage",
        "Tools::Surveys::SurveyResponse": "Sondage",
        "Tools::TextEditor::Document": "Éditeur de texte",
        "Tools::Website::Page": "Site web",
        "Tools::WordClouds::WordCloud": "Nuage de mots",
        "Tools::WordClouds::WordEntry": "Nuage de mots",
        "Tools::Worksheet::Response": "Soumission",
        "Tools::Worksheet::Worksheet": "Fiche d'exercices",
        "VideoRecorder::File": "Enregistrement vidéo",
        "folder": "Dossier"
      },
      "languages": {
        "de": "Allemand",
        "en": "Anglais",
        "es": "Espagnol",
        "fr": "Français",
        "it": "Italien",
        "nl": "Néerlandais",
        "ru": "Russe",
        "ua": "Ukrainien"
      },
      "privacyLevel": {
        "locked": "Bloqué",
        "members_only": "Membres uniquement",
        "password_protected": "Protégé par mot de passe",
        "public_for_all": "Disponible en tant qu'OER",
        "secret": "Visible"
      },
      "profileGradeTypes": {
        "GRADE_TYPE_ELEMENTARY_SCHOOL": "École primaire",
        "GRADE_TYPE_LOWER_GRADE": "Collège",
        "GRADE_TYPE_MIDDLE_LEVEL": "Cycle moyen",
        "GRADE_TYPE_OTHER": "Autre",
        "GRADE_TYPE_SPECIAL_SCHOOL": "École spécialisée",
        "GRADE_TYPE_UPPER_SCHOOL": "Lycée",
        "GRADE_TYPE_VOCATIONAL_SCHOOL": "École professionnelle"
      },
      "schoolTypes": {
        "SCHOOL_TYPE_ACADEMIC_HIGH_SCHOOL": "Gymnase",
        "SCHOOL_TYPE_COMPREHENSIVE_SCHOOL": "École intégrée",
        "SCHOOL_TYPE_CUSTOM": "Autre",
        "SCHOOL_TYPE_ELEMENTARY_SCHOOL": "École primaire",
        "SCHOOL_TYPE_MAIN_SCHOOL": "École secondaire",
        "SCHOOL_TYPE_MIDDLE_SCHOOL": "Collège",
        "SCHOOL_TYPE_SECONDARY_SCHOOL": "École secondaire",
        "SCHOOL_TYPE_SPECIAL_SCHOOL": "École spécialisée",
        "SCHOOL_TYPE_UNIVERSITY": "Université",
        "SCHOOL_TYPE_VOCATIONAL_SCHOOL": "École professionnelle"
      },
      "subjectTypes": {
        "SUBJECT_TYPE_ART": "Arts",
        "SUBJECT_TYPE_BIOLOGY": "Biologie",
        "SUBJECT_TYPE_CHEMISTRY": "Chimie",
        "SUBJECT_TYPE_COMPUTER_SCIENCE": "Informatique",
        "SUBJECT_TYPE_ECONOMY": "Économie",
        "SUBJECT_TYPE_ENGLISH": "Anglais",
        "SUBJECT_TYPE_ESL": "FLE/FLS",
        "SUBJECT_TYPE_ETHICS": "Éthique",
        "SUBJECT_TYPE_FOREIGN_LANGUAGES": "Didactique des langues étrangères",
        "SUBJECT_TYPE_GEOGRAPHIE": "Géographie",
        "SUBJECT_TYPE_GERMAN": "Allemand",
        "SUBJECT_TYPE_HISTORY": "Histoire",
        "SUBJECT_TYPE_MATH": "Mathématiques",
        "SUBJECT_TYPE_MEDIA": "Médias",
        "SUBJECT_TYPE_MUSIC": "Musique",
        "SUBJECT_TYPE_NATURAL_SCIENCES": "Sciences naturelles",
        "SUBJECT_TYPE_OTHER": "Autre",
        "SUBJECT_TYPE_PERSONAL_EDUCATION": "Sciences sociales",
        "SUBJECT_TYPE_PHILOSOPHIE": "Philosophie",
        "SUBJECT_TYPE_PHYSICS": "Physique",
        "SUBJECT_TYPE_POLITICS": "Société/Politique",
        "SUBJECT_TYPE_RELIGION": "Religion",
        "SUBJECT_TYPE_SPORT": "Sport",
        "SUBJECT_TYPE_TECHNOLOGY": "Technologie",
        "SUBJECT_TYPE_UNSPECIFIC": "Interdisciplinaire"
      }
    },
    "flash": {
      "addFileSuccess": "Fichier {filename} ajouté",
      "errorOccurred": "Une erreur est survenue. Veuillez réessayer.",
      "premiumLimitWarning": "Il ne reste qu'une demande Premium pour aujourd'hui | Il ne reste que {count} demandes Premium pour aujourd'hui",
      "premiumLimitResetsAtMidnight": "La limite sera réinitialisée à minuit.",
      "premiumLimitFallback": "Limite Premium pour aujourd'hui atteinte",
      "premiumLimitFallbackDescription": "{model} prend le relais jusqu'à minuit.",
      "premiumLimitReached": "Limite Premium pour aujourd'hui atteinte",
      "premiumLimitReachedDescription": "À partir de minuit, tu pourras à nouveau utiliser les modèles Premium.",
      "alreadyLoggedIn": "Vous êtes déjà connecté",
      "bookmarkSuccess": "Ajouté à la liste de favoris",
      "bookmarkSuccessLink": "Voir la liste de favoris",
      "connectionReestablished": "Connexion rétablie",
      "paidLicenseRequired": "Cet outil nécessite une licence payante",
      "remixStarted": "\"{name}\" est remixé",
      "remixSuccess": "\"{name}\" a été créé",
      "removeFileSuccess": "Fichier {filename} supprimé",
      "successfullyCreated": "Créé avec succès",
      "successfullyDeleted": "Supprimé avec succès",
      "successfullyUpdated": "Mis à jour avec succès",
      "templateMarkSuccess": "{name} marqué comme modèle",
      "tooManyRequests": "Trop de demandes. Veuillez réessayer dans quelques secondes.",
      "templateUnmarkSuccess": "{name} retiré comme modèle",
      "unbookmarkSuccess": "Retiré de la liste de favoris",
      "undiscardItemSuccess": "\"{name}\" a été restauré"
    },
    "footer": {
      "aboutUs": "À propos de fobizz",
      "aiAndTools": "IA et outils",
      "aiAndToolsHelp": "Aide sur les outils et applications IA",
      "aiGuidelines": "Utilisation de l'IA (EU AI Act)",
      "alternativeText": "Label de protection des données, garantissant une protection élevée et vérifiée",
      "certificatesHelp": "Aide sur les certificats",
      "company": "Entreprise",
      "courses": "Formations",
      "coursesHelp": "Aide sur les formations et webinaires",
      "enrollmentHelp": "Aide sur les inscriptions",
      "freeTrial": "Accès gratuit à l'essai",
      "gettingStarted": "Conseils pour débuter avec fobizz",
      "helpAndContact": "Aide et contact",
      "imprint": "Mentions légales",
      "jobs": "Emplois",
      "appStoreAriaLabel": "Télécharger sur l'App Store",
      "getTheApp": "Télécharger l'appli :",
      "googlePlayAriaLabel": "Disponible sur Google Play",
      "language": "Langue",
      "legal": "Légal",
      "licenses": "Licences",
      "newsletter": "S'abonner à la newsletter",
      "partners": "Nos partenaires",
      "partnersHelp": "Aide sur les partenaires",
      "privacyPolicy": "Protection des données",
      "schoolLicensePrices": "Tarifs pour licences scolaires et de groupe",
      "shareWithColleagues": "Partager du contenu avec des collègues",
      "shareWithStudents": "Partager du contenu avec des élèves",
      "singleLicensePrices": "Tarifs pour licences individuelles",
      "tAndC": "CGU",
      "teachingMaterial": "Matériel pédagogique",
      "teachingMaterialHelp": "Aide sur le matériel pédagogique",
      "team": "Équipe",
      "technicalHelp": "Premiers secours en cas de problèmes",
      "toTeach": "fobizz et Accéder à to teach",
      "urls": {
        "aboutUs": "https://fobizz.com/de/was-ist-fobizz/",
        "aiAndTools": "https://app.fobizz.com",
        "aiAndToolsHelp": "https://app.fobizz.com/de/help/categories/54-fobizz-tools",
        "aiGuidelines": "https://app.fobizz.com/de/help/categories/60-k-guidelines",
        "certificatesHelp": "https://app.fobizz.com/de/help/articles/78-weiterbildung-zertifikat-erhalten",
        "courses": "https://app.fobizz.com/fortbildungen",
        "coursesHelp": "https://app.fobizz.com/de/help/categories/50-fortbildungen",
        "enrollmentHelp": "https://app.fobizz.com/de/help/articles/311-kurs-einschreiben",
        "freeTrial": "https://app.fobizz.com/de/help/articles/310-fobizz-kostenfrei-testen",
        "gettingStarted": "https://app.fobizz.com/de/help/articles/133-start-empfehlungen",
        "helpAndContact": "https://app.fobizz.com/de/help",
        "imprint": "https://app.fobizz.com/imprints",
        "jobs": "https://fobizz.com/de/unsere-jobs/",
        "licenses": "https://app.fobizz.com/de/help/articles/273-kosten-fobizz",
        "newsletter": "https://fobizz.com/de/neuigkeiten-per-newsletter",
        "partners": "https://app.fobizz.com/partners",
        "partnersHelp": "https://app.fobizz.com/de/help/categories/56-unsere-partner",
        "privacyPolicy": "https://app.fobizz.com/data_protections",
        "schoolLicensePrices": "https://app.fobizz.com/de/help/articles/102-schullizenz-preise-und-paketgroessen",
        "shareWithColleagues": "https://app.fobizz.com/de/help/articles/26-wie-kann-ich-materialien-mit-meinen-kolleg-innen-teilen",
        "shareWithStudents": "https://app.fobizz.com/de/help/articles/20-inhalte-mit-schueler-innen-teilen",
        "singleLicensePrices": "https://app.fobizz.com/de/help/articles/279-abo-einzelizenz",
        "teachingMaterial": "https://app.fobizz.com/gallery",
        "teachingMaterialHelp": "https://app.fobizz.com/de/help/categories/59-unterrichtsmaterialien",
        "team": "https://fobizz.com/de/team/",
        "technicalHelp": "https://app.fobizz.com/de/help/categories/62-technische-probleme",
        "termsAndConditions": "https://app.fobizz.com/terms_and_conditions",
        "toTeach": "https://fobizz.com/de/to-teach/",
        "useToolsWithStudents": "https://app.fobizz.com/de/help/articles/309-tools-schueler-innen-nutzen"
      },
      "useToolsWithStudents": "Utiliser les outils avec les élèves"
    },
    "headers": {
      "aiImageSearch": "Mes images IA",
      "auto_cleanup": "Suppression automatique",
      "background": "Arrière-plan",
      "backgroundColor": "Couleur de fond",
      "backgroundPreview": "Aperçu de l'arrière-plan",
      "camera": "Caméra",
      "colorAndPattern": "Couleur et motif",
      "colors": "Couleurs",
      "editFolder": "Modifier le dossier",
      "files": "Fichiers",
      "hint": "Remarque",
      "image": "Image",
      "imageSearch": "Recherche d'images",
      "imageUploadHint": "Vous pouvez maintenant le voir sur la fiche d'exercices",
      "imageUploadSuccess": "Image téléchargée avec succès.",
      "images": "Images",
      "previewImage": "Image d'aperçu",
      "latex": "LaTeX",
      "link": "Lien",
      "microphone": "Microphone",
      "patterns": "Motif",
      "recording": "Enregistrement",
      "settings": "Paramètres",
      "share": "Partager",
      "statistics": "Statistiques",
      "toolSpecificFaqs": "Questions sur l'outil {name}",
      "videoTutorial": "Comment fonctionne cet outil",
      "views": "Vues",
      "visitorPermissions": "Autorisation des visiteurs"
    },
    "feedback": {
      "thumbsDown": "Pas utile",
      "thumbsUp": "J'aime"
    },
    "help": {
      "autoCleanup": {
        "day": "Les données sont supprimées après un jour.",
        "month": "Les données sont supprimées après un mois.",
        "never": "Les données ne sont pas supprimées automatiquement.",
        "week": "Les données sont supprimées après une semaine."
      },
      "embed": "Copiez le code snippet pour l'intégrer via iframe dans d'autres sites web.",
      "jsRequired": "JavaScript est requis",
      "maxCharacters": "Maximum {max} caractères",
      "privacyLevel": {
        "locked": "Cachez les contenus ultérieurement ou temporairement. Seul vous pouvez les voir et les modifier.",
        "members_only": "Non public. Seuls les membres connectés ont accès.",
        "password_protected": "Protégez les contenus avec un mot de passe supplémentaire.",
        "public_for_all": "Publiez les contenus en tant que OER dans la galerie fobizz pour le matériel pédagogique. <a href=\"/gallery/how_to\" target=\"_blank\">En savoir plus</a>",
        "secret": "Seules les personnes à qui vous envoyez le lien peuvent réutiliser les contenus."
      },
      "privacyLevelInLibrary": {
        "locked": "Masque les contenus. Seuls toi et les enseignant·es de ton école pouvez les voir."
      },
      "visitorPermissions": {
        "visitor_permissions_invisible": "Les visiteurs ne peuvent pas voir les contenus.",
        "visitor_permissions_read": "Les visiteurs peuvent voir les contenus.",
        "visitor_permissions_write": "Les visiteurs peuvent modifier les contenus."
      }
    },
    "hints": {
      "allowedFileTypes": "Types de fichiers autorisés",
      "converting": "Fichier en cours de conversion...",
      "copied": "Copié dans le presse-papiers",
      "creating": {
        "docx": "Document Word en cours de création...",
        "pdf": "PDF en cours de création...",
        "pptx": "Présentation PowerPoint en cours de création..."
      },
      "dataProtectionFileUpload": "Ne télécharge pas d'informations sensibles ou personnelles et respecte les droits d'auteur lors de l'utilisation de contenus tiers.",
      "dataProtectionFileUploadTitle": "Protège tes données lors du téléchargement de fichiers",
      "dragDrop": "Astuce : Tu peux télécharger un fichier par glisser-déposer",
      "dragOrSelectFile": "Glisser l'image ici ou",
      "dragOrSelectImage": "Glisser l'image ici ou sélectionner",
      "imageUploading": "Image en cours de téléchargement...",
      "drop": "Déposer le fichier ici",
      "dropFile": "Glisser le fichier ici ou",
      "embedIFrame": "En cliquant sur cette image d'aperçu, tu acceptes que les contenus affichés soient rechargés et que les données nécessaires, notamment ton adresse IP, soient transmises au fournisseur des contenus. Pour plus d'informations, consulte notre politique de confidentialité.",
      "embedIFramePupil": "En cliquant sur cette image d'aperçu, les contenus affichés seront rechargés et les données nécessaires, notamment ton adresse IP, seront transmises au fournisseur des contenus. En cas de doute, demande à ton enseignant·e.",
      "exampleAlert": "À quoi cela peut-il ressembler ?",
      "exampleButton": "Insérer un exemple",
      "fileLimit": "(maximum {size} MB)",
      "inputLabel": "Ton Prompt",
      "latexSyntax": "Tu peux utiliser la <a href=\"https://katex.org/docs/supported\" target=\"_blank\">syntaxe LaTeX</a>",
      "legacyBrowserBanner": "Il semble que tu utilises un navigateur obsolète. Veuillez mettre à jour votre navigateur pour profiter pleinement de notre site web. Avec un navigateur à jour, tu améliores non seulement ta sécurité, mais aussi l'affichage et la fonctionnalité de notre site.",
      "loading": "Chargement...",
      "maxFileSize": "Maximum {size} MB",
      "maxRecordingLength": "Les enregistrements peuvent durer jusqu'à 4 minutes.",
      "noItems": "Tu n'as encore rien créé ici. Commence maintenant !",
      "noOptions": "La liste est vide",
      "noResults": "Aucun résultat",
      "notSpecified": "Pas encore d'indication",
      "ready": {
        "docx": "Document Word fourni",
        "pdf": "PDF fourni",
        "pptx": "Présentation PowerPoint fournie"
      },
      "previewImageDragDrop": "Glisser l'image ici ou cliquer pour télécharger",
      "progressMessage": "En cours de traitement...",
      "progressMessageQueued": "En file d'attente...",
      "prompt": "Important : Ne partage jamais de données personnelles avec l'IA et vérifie les réponses de manière critique.",
      "selectFile": "Sélectionner un fichier",
      "serverStatus": "Il y a beaucoup d'activité en ce moment et nos outils sont très sollicités. Il se peut que ta demande prenne plus de temps que d'habitude. Merci pour ta patience. Nous travaillons déjà à rétablir la vitesse normale du système.",
      "settingsSaved": "Tes paramètres ont été enregistrés.",
      "submittingDescription": "Si cela prend plus de temps : Le processus continue en arrière-plan. Tu peux faire autre chose entre-temps et trouver le résultat dans l'historique en haut à droite.",
      "uploading": "Fichier en cours de téléchargement...",
      "uploadingProgress": "Fichier en cours de téléchargement : {progress}",
      "visitorMaterial": "Tu utilises fobizz en tant qu'invité - tous les contenus seront supprimés après 2 jours. <strong><a href=\"{url}\" target=\"_blank\">Connecte-toi</a></strong> pour enregistrer tes contenus."
    },
    "infoModal": {
      "classroom_screen": "<h3><strong>Plan de cours</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Thème</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Nom / Thème de l'unité d'enseignement</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Temps recommandé</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>par ex. 45/90 minutes</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Objectif d'apprentissage</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Quel est l'objectif principal de la leçon ? Quelle compétence doit être acquise à la fin de la leçon ?</em></p></td></tr></tbody></table><p></p><h3><strong>Planification du déroulement</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Durée (Min)</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Phase</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Activité en classe / Interaction enseignant·e-élève</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Forme sociale / Forme de travail</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Médias / Matériaux</strong></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>5</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Introduction</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>10</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Développement</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td></tr></tbody></table><p></p><p><strong>Informations supplémentaires</strong></p><p><em>Description des contenus et du déroulement de l'unité d'enseignement. Conseils pour la mise en œuvre et la préparation du cours. Éventuellement, explications sur le lien avec le programme et les choix didactiques et méthodologiques.</em></p><p></p>",
      "title": "Informations supplémentaires pour les enseignant·e·s"
    },
    "labels": {
      "aiEnabled": "IA activée",
      "authorName": "Auteur·e",
      "confirm": "Confirmer",
      "continue": "Suivant",
      "customSubjectType": "Autre matière scolaire",
      "description": "Description",
      "notSpecified": "Non indiqué",
      "gradeLevels": "Niveaux de classe",
      "imageSearch": {
        "categories": "Animaux, dinosaures, nature, paysage, plage, mer, ciel, espace, voiture, objets, mode, bureau, enfants, personnes, famille, histoires",
        "noMoreResults": "Aucune autre image trouvée"
      },
      "itemTotals": "{firstItem} - {lastItem} sur {totalCount} entrées",
      "language": "Langue",
      "latex": "Entrée LaTeX",
      "loading": "Chargement...",
      "name": "Nom",
      "new": "Nouveau",
      "nextPage": "Page suivante",
      "page": "Page",
      "previousPage": "Page précédente",
      "password": "Mot de passe",
      "peopleCount": "1 personne | {count} personnes",
      "preview": "Aperçu",
      "pseudonym": "Entrez ici votre pseudonyme ou initiales.",
      "schoolTypes": "Types d'école",
      "search": "Recherche",
      "subjectTypes": "Matières scolaires",
      "title": "Titre",
      "withAi": "Avec IA"
    },
    "languages": {
      "de": "Allemand",
      "en": "Anglais",
      "es": "Espagnol",
      "fr": "Français"
    },
    "limitUpsellBox": {
      "bodySubtitleHtml": "Recommande à ton établissement la <strong>licence scolaire fobizz</strong> ou prends la <strong>licence individuelle</strong> juste pour toi.",
      "bodyTitle": "Souhaitez-vous utiliser fobizz sans limite ?",
      "header": {
        "ai_assistant": {
          "multiple": "<strong>{more} {number} assistants</strong> créer",
          "one": "<strong>encore un assistant</strong> créer"
        },
        "ai_chat": {
          "multiple": "laisser le Chat IA vous donner <strong>{more} {number} réponses</strong>",
          "one": "laisser le Chat IA vous donner <strong>encore une réponse</strong>"
        },
        "ai_chat_completion": {
          "multiple": "recevoir <strong>{more} {number} réponses</strong> du Chat IA",
          "one": "recevoir <strong>une réponse</strong> du Chat IA"
        },
        "ai_converter": {
          "multiple": "faire <strong>{more} {number} demandes</strong> à l'outil multimédia IA",
          "one": "faire <strong>encore une demande</strong> à l'outil multimédia IA"
        },
        "ai_document_qa": {
          "multiple": "télécharger <strong>{more} {number} documents</strong> pour l'IA pour documents",
          "one": "télécharger <strong>encore un document</strong> pour l'IA pour documents"
        },
        "ai_feedback": {
          "multiple": "faire <strong>{more} {number} demandes</strong> à l'aide à la correction IA",
          "one": "faire <strong>encore une demande</strong> à l'aide à la correction IA"
        },
        "ai_image": {
          "multiple": "créer <strong>{more} {number} images</strong>",
          "one": "créer <strong>une image</strong>"
        },
        "ai_mini_tool": {
          "multiple": "faire <strong>{more} {number} demandes</strong> au laboratoire de prompts",
          "one": "faire <strong>encore une demande</strong> au laboratoire de prompts"
        },
        "ai_persona": {
          "multiple": "faire <strong>{more} {number} demandes</strong> à l'IA pour personnes",
          "one": "faire <strong>encore une demande</strong> à l'IA pour personnes"
        },
        "audio_recorder": {
          "multiple": "faire <strong>{more} {number} enregistrements audio</strong>",
          "one": "faire <strong>encore un enregistrement audio</strong>"
        },
        "classroom_screen": {
          "multiple": "créer <strong>{more} {number} tableaux</strong>",
          "one": "créer <strong>encore un tableau</strong>"
        },
        "file_sharing": {
          "multiple": "partager <strong>{more} {number} fichiers</strong>",
          "one": "partager <strong>encore un fichier</strong>"
        },
        "licenseRequiredHtml": "<h2>Pour utiliser cet outil, vous avez besoin d'une licence fobizz.</h2><p>Informez-vous sur nos licences pour une utilisation illimitée.</p>",
        "limitReachedHtml": "<h2>Vous avez atteint votre limite mensuelle pour cet outil.</h2><p>Informez-vous sur nos licences pour une utilisation illimitée.</p>",
        "limitReachedVisitor": "Vous avez épuisé votre limite quotidienne de réponses de l'assistant IA.",
        "link_shortener": {
          "multiple": "raccourcir <strong>{more} {number} liens</strong>",
          "one": "raccourcir <strong>encore un lien</strong>"
        },
        "monthlyLimitNotReached": "Vous pouvez encore {actionText} ce mois-ci.",
        "monthlyLimitNotReachedVisitor": "En tant qu'invité, vous pouvez encore {actionText} ce mois-ci",
        "more": "plus",
        "pinboard": {
          "multiple": "créer <strong>{more} {number} tableaux d'affichage</strong>",
          "one": "créer <strong>encore un tableau d'affichage</strong>"
        },
        "pupil_feedback": {
          "multiple": "créer <strong>{more} {number} tâches</strong> avec l'IA pour feedback",
          "one": "créer <strong>encore une tâche</strong> avec l'IA pour feedback"
        },
        "qrcodes": {
          "multiple": "créer <strong>{more} {number} QR-Codes</strong>",
          "one": "créer <strong>encore un QR-Code</strong>"
        },
        "registerNow": "<strong><a href=\"{url}\" target=\"_blank\">Inscrivez-vous gratuitement</a></strong> pour continuer à travailler avec les outils.",
        "school_classes": {
          "multiple": "créer <strong>{more} {number} salles de classe</strong>",
          "one": "créer <strong>encore une salle de classe</strong>"
        },
        "screen_recorder": {
          "multiple": "faire <strong>{more} {number} enregistrements d'écran</strong>",
          "one": "faire <strong>encore un enregistrement d'écran</strong>"
        },
        "shared_space_link": {
          "multiple": "créer <strong>{more} {number} salles de classe</strong>",
          "one": "créer <strong>encore une salle de classe</strong>"
        },
        "surveys": {
          "multiple": "créer <strong>{more} {number} sondages</strong>",
          "one": "créer <strong>encore un sondage</strong>"
        },
        "text_editor": {
          "multiple": "créer <strong>{more} {number} documents texte</strong>",
          "one": "créer <strong>encore un document texte</strong>"
        },
        "video_recorder": {
          "multiple": "faire <strong>{more} {number} enregistrements vidéo</strong>",
          "one": "faire <strong>encore un enregistrement vidéo</strong>"
        },
        "website": {
          "multiple": "créer <strong>{more} {number} sites web</strong>",
          "one": "créer <strong>encore un site web</strong>"
        },
        "word_clouds": {
          "multiple": "créer <strong>{more} {number} nuages de mots</strong>",
          "one": "créer <strong>encore un nuage de mots</strong>"
        },
        "worksheet": {
          "multiple": "créer <strong>{more} {number} fiches d'exercices</strong>",
          "one": "créer <strong>encore une fiche d'exercices</strong>"
        }
      },
      "activation": {
        "question": "Votre établissement a déjà une licence ?",
        "success": "Licence activée avec succès ! Vous êtes maintenant membre de \"{groupTitle}\"."
      },
      "upsellCard": {
        "group": {
          "description": "La licence de groupe est rentable à partir de 5 personnes.",
          "linkText": "Infos sur la licence de groupe",
          "linkUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
          "title": "Ensemble avec des collègues"
        },
        "individual": {
          "description": "Découvrez toutes les offres pour vous en tant qu'enseignant individuel.",
          "linkText": "Infos sur la licence individuelle",
          "linkUrl": "https://app.fobizz.com/pricing",
          "title": "Individuellement pour vous"
        }
      }
    },
    "links": {
      "accept": "J'ai pris connaissance des indications",
      "aiAssistants": "Assistants IA",
      "aiImageSearch": "Mes images IA",
      "back": "Retour",
      "back_to_curriculum": "Retour à l'aperçu",
      "clickToEdit": "Cliquer pour éditer",
      "close": "Fermer",
      "copied": "Copié !",
      "copy": "Copier",
      "create": "Créer",
      "createNew": "Nouveau",
      "createTool": "Créer {name}",
      "createWithTemplate": "Choisir un modèle",
      "createWithoutTemplate": "Créer",
      "dataProtection": "Confidentialité",
      "delete": "Supprimer",
      "discard": "Déplacer dans la corbeille",
      "download": "Télécharger",
      "downloadCSV": "Télécharger en CSV",
      "duplicate": "Dupliquer",
      "edit": "Éditer",
      "exportAs": {
        "docx": "Exporter en Word",
        "pdf": "Exporter en PDF",
        "pptx": "Exporter en PowerPoint"
      },
      "freeRegistration": "S'inscrire maintenant",
      "gallery": "Galerie",
      "generateWithAi": "Générer avec l'IA",
      "history": "Historique",
      "imageSearch": "Recherche d'images",
      "imageSearchPexels": "Recherche d'images sur Pexels",
      "imageSearchPixabay": "Recherche d'images sur Pixabay",
      "imprint": "Mentions légales",
      "learnMore": "En savoir plus",
      "legal": "Légal",
      "licenseInfo": "Infos sur la licence",
      "logout": "Se déconnecter",
      "moreSettings": "Autres paramètres",
      "move": "Déplacer",
      "moveToFolder": "Déplacer dans le dossier",
      "new": "Créer",
      "open": "Ouvrir",
      "openAttachment": "Ouvrir l'annexe",
      "openRow": "Ouvrir {name}",
      "opensInNewTab": "s'ouvre dans un nouvel onglet",
      "overview": "Aperçu",
      "preview": "Aperçu",
      "print": "Imprimer",
      "remix": "Remix",
      "remove": "Retirer",
      "reportContent": "Signaler le contenu",
      "saveImage": "Enregistrer l'image",
      "savePdf": "Enregistrer le PDF",
      "search": "Recherche",
      "settings": "Paramètres",
      "share": "Partager",
      "showAll": "Tout afficher",
      "showMore": "Afficher plus",
      "showQrCode": "Afficher le QR code",
      "signup": "S'inscrire",
      "templateToggle": "Utiliser comme modèle",
      "termsAndConditions": "CGU",
      "themeEditor": "Personnaliser l'arrière-plan",
      "toolInfos": "Tutoriel et aide",
      "tryNow": "Essayer maintenant",
      "undiscard": "Restaurer",
      "uploadFile": "Télécharger le fichier",
      "uploadImage": "Télécharger l'image"
    },
    "palette": {
      "colors": {
        "apricot": "Abricot",
        "gray": "Gris",
        "lavender": "Lavande",
        "lightBlue": "Bleu clair",
        "lightGreen": "Vert clair",
        "mauve": "Mauve",
        "mint": "Menthe",
        "pink": "Rose",
        "salmon": "Saumon",
        "white": "Blanc",
        "yellow": "Jaune"
      },
      "noColor": "Aucune couleur",
      "noPattern": "Aucun motif"
    },
    "placeholders": {
      "anonymous": "Anonyme",
      "answer": "Entrez la réponse ici...",
      "description": "Entrez la description ici...",
      "password": "Entrez le mot de passe...",
      "question": "Entrez la question ici...",
      "selectOption": "Veuillez sélectionner"
    },
    "preview": {
      "editLink": "Modifier le matériel",
      "hint": "Vous êtes dans l’aperçu.",
      "title": "Aperçu"
    },
    "profileStatus": {
      "licenses": {
        "courses": {
          "basic": {
            "label": "Formations Basic",
            "tooltip": "Tu peux utiliser les formations gratuites. Si tu veux accéder à tout, nous te recommandons la Formations-Flatrate ou la Licence scolaire de formations."
          },
          "group": {
            "label": "Licence scolaire de formations",
            "tooltip": "Tu as la Licence scolaire de formations. Tu peux donc utiliser toutes les formations."
          },
          "pro": {
            "label": "Formations-Flatrate",
            "tooltip": "Tu as la Formations-Flatrate. Tu peux donc utiliser toutes les formations."
          }
        },
        "tools": {
          "basic": {
            "label": "Outils Basic",
            "tooltip": "Tu peux utiliser les outils, mais avec une limite par outil. Si tu veux utiliser tous les outils sans limite, nous te recommandons la Outils-Flatrate ou la Licence scolaire d'outils."
          },
          "group": {
            "label": "Licence scolaire d'outils",
            "tooltip": "Tu as la Licence scolaire d'outils. Tu peux donc utiliser les outils sans limite."
          },
          "pro": {
            "label": "Outils-Flatrate",
            "tooltip": "Tu as la Outils-Flatrate. Tu peux donc utiliser les outils sans limite."
          }
        }
      }
    },
    "qrcodeModal": {
      "title": "QR code"
    },
    "remixModal": {
      "alert": "Pour cet assistant, les connaissances de base ne sont pas disponibles pour le remix. Tu peux simplement ajouter ton propre contexte.",
      "button": "Remixer les contenus maintenant",
      "licenseHint": "Remarque : Ce contenu est sous licence Creative Commons CC-BY, ce qui signifie que tu dois citer l'auteur·e lors de la réutilisation.",
      "loginPrompt": "Connecte-toi à ton compte fobizz pour remixer ces contenus et les utiliser dans ton propre enseignement.",
      "paragraph": "Avec l'option Remix, tu crées une copie personnelle de ces contenus que tu peux modifier et adapter.",
      "hint": "⏳ Remarque : Pour les contenus volumineux, le remix peut prendre un certain temps - le processus continue en arrière-plan. Tu trouveras le contenu plus tard dans ton espace de stockage.",
      "toLogin": "S'inscrire à fobizz"
    },
    "response": {
      "labels": {
        "submission": "Soumission | Soumissions"
      }
    },
    "settingsModal": {
      "labels": {
        "autoCleanup": "{modelName} sera supprimé après cette période :"
      }
    },
    "shareOptions": {
      "buttons": {
        "create24hProject": "Salle de classe • 24 h",
        "createSchoolClass": "Salle de classe • 1 an",
        "selectProject": "Sélectionner la salle de classe et le projet",
        "shareInSchoolClass": "Partager dans la salle de classe",
        "showQRCode": "Afficher le QR-Code"
      },
      "defaultNames": {
        "project24h": "Ton projet 24h"
      },
      "hints": {
        "alreadyShared": "Tu as déjà partagé ce contenu dans ce projet. Veuillez choisir un autre projet.",
        "error": "Une erreur est survenue lors de la mise à jour de la salle de classe. Veuillez réessayer.",
        "errorShareSettings": "Une erreur est survenue lors de l'enregistrement des paramètres de partage. Veuillez réessayer.",
        "locked": "Contenu verrouillé. Seul toi peux le voir et le modifier.",
        "lockedInLibrary": "Contenu verrouillé. Seuls toi et les enseignant·es de ton école pouvez le voir.",
        "noSchoolClass": "Tu n'as pas encore créé de salle de classe. Crée-en une pour partager des contenus.",
        "password_protected": "Le lien de partage est protégé par mot de passe.",
        "public_for_all": "Le contenu est partagé en tant qu'OER et publié dans la galerie fobizz.",
        "schoolClassWithoutProject": "Tu n'as pas encore créé de projet pour cette salle de classe. Crée un projet pour partager des contenus.",
        "secret": "Le contenu est accessible via un lien de partage.",
        "sharedInClassroom": "Partagé dans la salle de classe.",
        "invitedBy": "Invitation de {name}",
        "discardedByOwner": "Supprimé par {name}",
        "success": "Ta salle de classe a été mise à jour.",
        "successRemove": "Le contenu a été retiré de ta salle de classe."
      },
      "labels": {
        "categories": "Catégories",
        "iFrame": "Par iFrame",
        "project": "Projet",
        "schoolClass": "Dans la salle de classe",
        "shareInSchoolClass": "Partager des contenus dans la salle de classe",
        "shareLink": "Par lien de partage",
        "shareSpace": "Salle de classe",
        "sharingSettings": "Paramètres de partage"
      },
      "options": {
        "select": "Sélectionner"
      }
    },
    "spinnerDialog": {
      "text": "Le processus prend encore un peu de temps"
    },
    "stockImageTypes": {
      "illustration": "Illustration",
      "photo": "Photo",
      "vector": "Vecteur"
    },
    "templatesModal": {
      "emptyHint": "Tu n'as encore enregistré aucun modèle personnel.",
      "header": "Modèles",
      "paragraph": "Commencez avec un modèle personnel ou créé par fobizz.",
      "tabFobizzTemplates": "Modèles fobizz",
      "tabYourTemplates": "Modèles personnels"
    },
    "time": {
      "oClock": "Heure",
      "today": "Aujourd'hui",
      "tomorrow": "Demain"
    },
    "pseudonymModal": {
      "titles": {
        "pupil_feedback": "Feedback IA"
      }
    },
    "visitorPermissions": {
      "visitor_permissions_invisible": "Masqué",
      "visitor_permissions_read": "Lire",
      "visitor_permissions_write": "Écrire"
    },
    "aiGenerated": {
      "label": "Généré par l'IA",
      "tooltip": "Cette image a été créée avec de l'intelligence artificielle"
    },
    "confirms": {
      "reRecord": {
        "confirm": "Annuler et recommencer",
        "text": "Votre enregistrement actuel sera annulé pour que vous puissiez en démarrer un nouveau.",
        "title": "Relancer l'enregistrement ?"
      },
      "unsavedChanges": {
        "discard": "Rejeter",
        "text": "Vous avez des modifications non enregistrées. Voulez‑vous les enregistrer ?",
        "title": "Modifications non enregistrées"
      }
    },
    "codeBlock": {
      "copied": "Copié !",
      "copyFailed": "Échec de la copie",
      "defaultFilename": "page",
      "download": "Télécharger en HTML",
      "fullscreen": "Plein écran",
      "preview": "Aperçu",
      "reload": "Recharger",
      "source": "Code"
    }
  }
}
